import { IAssetUpdate } from './asset-update.interface.js';
import { IDealUpdate } from './deal-update.interface.js';
import { IFundingUpdate } from './funding-update.interface.js';
import { IUpdateEntity } from './model-entity.interface.js';
import {
	ProcessedStatus,
	UpdateStatus,
	IUpdateField,
} from './update-field.interface.js';

export interface ICompanyUpdate extends IUpdateEntity {
	approverEmailAddress: string;
	comments: string;
	isNoteworthy: boolean;
	processed: ProcessedStatus;
	status: UpdateStatus;
	assetUpdates: IAssetUpdate[];
	dealUpdates: IDealUpdate[];
	fundingUpdates: IFundingUpdate[];
	updateFields: IUpdateField[];
}

export enum EditItemType {
	Default,
	Logo,
	MultiChoice,
	Multiline,
	ConstrainedValue,
	Numeric,
	MultiModal,
	Year,
	Currency,
}

export enum DynamicChoiceKey {
	LeadershipDiversity,
	BoardAdvisorDiversity,
	RDStage,
	PrimarySubsector,
	SecondarySubsector,
	Tags,
	FocusArea,
	DevelopmentStage,
}

export enum UpdateConversion {
	BooleanToYesNo,
	DelimitedString,
	CountryPrefixedDelimitedString,
	CorrectedWhitespace,
	ValidWebsite,
	DateString,
}

export const ArrayConversions = [
	UpdateConversion.DelimitedString,
	UpdateConversion.CountryPrefixedDelimitedString,
];
